import React from 'react';
import { Button, DropdownSelect, Flex, Label } from '@zillow/constellation';

export const PaginationControls: React.FC<{
  currentPage: number;
  pageSize: number;
  totalElements: number;
  onPageChange: (updater: (curr: number) => number) => void;
  onPageSizeChange: (updater: (curr: number) => number) => void;
}> = ({ currentPage, pageSize, totalElements, onPageChange, onPageSizeChange }) => {
  const totalPages = Math.ceil(totalElements / pageSize);
  const hasNextPage = currentPage < totalPages;
  const hasPrevPage = currentPage > 1;

  return (
    <Flex display="flex" justifyContent="space-between" alignItems="center" paddingY="md">
      <Flex display="flex" alignItems="center" gap="sm">
        <Button onClick={() => onPageChange(() => 1)} disabled={!hasPrevPage} size="sm">
          First
        </Button>
        <Button onClick={() => onPageChange((curr) => curr - 1)} disabled={!hasPrevPage} size="sm">
          Previous
        </Button>
        <span className="text-sm font-normal text-gray-700">
          Page {currentPage} of {totalPages}
        </span>
        <Button onClick={() => onPageChange((curr) => curr + 1)} disabled={!hasNextPage} size="sm">
          Next
        </Button>
        <Button onClick={() => onPageChange(() => totalPages)} disabled={!hasNextPage} size="sm">
          Last
        </Button>
      </Flex>

      <Flex display="flex" alignItems="center" gap="sm">
        <Label>Page Size:</Label>
        <DropdownSelect
          options={['10', '25', '50', '100']}
          value={pageSize.toString()}
          onChange={(value) => onPageSizeChange(() => Number(value as string))}
        />
      </Flex>
    </Flex>
  );
};
